<template>
  <td>
    <div class="image" :style="maxHeight">
      <img :src="content" />
    </div>
  </td>
</template>

<style lang="scss" scoped>
.image {
  max-width: 200px;

  img {
    max-height: 100%;
  }
}
</style>

<script lang="babel">
export default {
    props: ['content', 'attribute'],
    computed: {
        maxHeight() {
            return this.attribute.maxHeight ? 'max-height: ' + this.attribute.maxHeight : null;
        }
    }
};
</script>
